export default "__VITE_ASSET__jCecqZ6N__"